import React from 'react';

import PropTypes from 'prop-types';
import DashboardMain from 'components/dashboard/DashboardMain';
import SidebarMenuAirSpaceDetails from './SidebarMenuAirSpaceDetails';
import SidebarMenuUSpaceDetails from './SidebarMenuUSpaceDetails';
import SidebarMenuSettingsDetails from './SidebarMenuSettingsDetails';
import SidebarMenuProfileDetails from './SidebarMenuProfileDetails';
import SidebarMenuAdminDetails from './SidebarMenuAdminDetails';

const SidebarMenuDetails = props => {
  const { details, isAdmin } = props;

  const handleProfile = () => <SidebarMenuProfileDetails />;
  const handleDashboard = () => <DashboardMain />;
  const handleUSpace = () => <SidebarMenuUSpaceDetails />;
  const handleAirSpace = () => <SidebarMenuAirSpaceDetails />;
  const handleSettings = () => <SidebarMenuSettingsDetails />;
  const handleAdmin = () => <SidebarMenuAdminDetails />;

  const handleSelectDetails = () => {
    switch (details) {
      case 'dashboard':
        return handleDashboard();
      case 'uspace':
        return handleUSpace();
      case 'airspace':
        return handleAirSpace();
      case 'settings':
        return handleSettings();
      case 'profile':
        return handleProfile();
      case 'admin':
        return isAdmin ? handleAdmin() : null;
      default:
        return null;
    }
  };

  return handleSelectDetails();
};

SidebarMenuDetails.propTypes = {
  details: PropTypes.string,
  isAdmin: PropTypes.func,
};

export default SidebarMenuDetails;
